import script from "./BuyForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuyForm.vue?vue&type=script&lang=ts&setup=true"

import "./BuyForm.vue?vue&type=style&index=0&id=376f9ab6&lang=scss&scoped=true"

import exportComponent from "/Users/BlackPaw/Developer/acebed_vue3_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-376f9ab6"]])

export default __exports__